



















import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import { NavBar, Cell, CellGroup, Button, Image } from "vant";
import WeMixin from "@/components/weMixin";
import Jssdk, { WxJsapiSignature } from "@/components/wechat/wechatJssdkMixin";

import vueQr from "vue-qr";
Vue.use(vueQr);

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Image.name]: Image,
  },
})
export default class YhfflToPbQRcode extends mixins(WeMixin, Jssdk) {
  private qrCodeText: string = "";

  protected created() {
    this.qrCodeText =
      "https://wap.psbc.com/mobilebank/weixinRecordOfReferences.do?type=03&custId=790697809&openOrg=32019537&newqrcodeflag=1";
  }
}
